import type { SVGProps } from 'react';

// PLACEHOLDER — replace per project.
//
// SVG brand assets are React components, not files fetched from /public after
// hydration: the header logo is above the fold, so an extra round trip after FCP
// is visible (see AGENTS.md → Performance).
//
// For a new project: add one `Logo<Name>.tsx` per variant next to this file,
// export them from `index.ts` and map them in `UiLogo.constants.ts`, then delete
// this file. Paint via `currentColor` so the mark inherits the surrounding color.
export function LogoPlaceholder(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 96 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="0.75" y="0.75" width="94.5" height="30.5" rx="3.25" stroke="currentColor" strokeWidth="1.5" />
            <path d="M12 22L20 10L28 22H12Z" fill="currentColor" />
            <rect x="36" y="14" width="48" height="4" rx="2" fill="currentColor" />
        </svg>
    );
}
